import Button from '@material-ui/core/Button';
import CardActions from '@material-ui/core/CardActions';
import ArrowBack from '@material-ui/icons/ArrowBack';
import FileCopyIcon from '@material-ui/icons/FileCopy';
//import CopyButton from './CopyButton'
//import PropTypes from 'prop-types';
import Print from '@material-ui/icons/Print';
import copy from 'copy-to-clipboard';
import React, { useEffect, useRef, useState } from 'react';
import { CreateButton, EditButton, ShowController, ShowView, useShowController } from 'react-admin';
//import Imprimer from './Imprimer';
import { Link } from "react-router-dom";
import { useReactToPrint } from 'react-to-print';
import Segment from '../communs/Segment.js';


/*
const suppSpaceStyle={
        marginTop:0,
        marginBottom:0,
        paddingTop:0,
        paddingBottom:0,
};

var record=null;
var ref=null;
*/

var infos='';

//var trans_code=null;
const ShowVersement=(props) => {

    const [print, setPrint] = useState(true);
    const [titre, setTitre] = useState(true);
    const [fullname, setFullname] = useState('');

    const { record } = useShowController(props);
    const componentRef = useRef();

  useEffect(() => {
      console.log(record)
    setFullname(localStorage.getItem('fullname'));
    
}, []);

 const copie=(data)=>{
    //                   "Montant : "+data.trans_amount+" €\n"+
     infos="Code : "+record.code+"\n"+
            "Crée par : "+record.created_by_name+"\n"+
            "Reçu par recep_by_name : "+record.recep_by_name+"\n"+
            "Montant : "+new Intl.NumberFormat().format(record.montant)+' '+record.devise+"\n"+
            "Mode paiement : "+record.mode_vst+"\n"+
            "Status : "+record.status+"\n"+
            "Date : "+record.vst_last_modified_date+"\n"
            ;
    copy(infos);
}

/*
impression(){
    this.setState({print:false}, () => {});
    //console.log(this.state.print);
}

function impression(){
    alert(JSON.stringify(record));
}
*/
const details=()=>{
    setPrint(false);
}

const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: titre
});
const PostShowActions = ({ basePath, data, resource }) => (
    <CardActions style={cardActionStyle}>
            <Button
                label="Copier"
                color="primary"
                onClick={()=>copie(data)}
            >
            <FileCopyIcon />
            </Button>

            <Button color="primary" onClick={handlePrint} label="Imprimer"><Print /></Button>

            <CreateButton basePath={basePath} />
            {data.status==='ATTENTE' ? <EditButton basePath={basePath} record={data} />:null}
            <Button component={Link} to={basePath} label="Retour" color="primary" ><ArrowBack/></Button>

    </CardActions>
);

    return (

        <ShowController {...props}>

            
                {controllerProps => 
                    <ShowView title={'Détails du versement:'+fullname} {...props} actions={<PostShowActions />} {...controllerProps}>
                        {controllerProps.record && print? 


               <Segment ref={componentRef}  tiket={true} code={controllerProps.record.code} datas={
                [
                    {id:'vst_created_date',label:'Date création',name:controllerProps.record.vst_created_date},
                    {id:'vst_last_modified_date',label:'Date revue',name:controllerProps.record.vst_last_modified_date},
                    {id:'status',label:'Status versement',name:controllerProps.record.status},
                    {id:'mode_vst',label:'Mode versement',name:controllerProps.record.mode_vst},
                    {id:'created_by_name',label:'Crée par',name:controllerProps.record.created_by_name},
                    {id:'type',label:'Type versement',name:controllerProps.record.type},
                    {id:'recep_by_name',label:'Reception par',name:controllerProps.record.recep_by_name},
                    {id:'montant',label:'Montant',name:controllerProps.record.montant+' '+controllerProps.record.devise},
                    {id:'commentaire',label:'Commentaire',name:controllerProps.record.commentaire}

                  ]
                } />

                :
                null
   
            }
                    </ShowView>
                }
            
           </ShowController>
        );
        
   

    


}

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    flexDirection: 'column'
};

export default ShowVersement;
